import { Control } from '../../../../types/types';

export const getDataType = (
  column: any,
  control?: Control
): string | undefined => {
  switch (column.type) {
    case 'string':
      return 'text';
    case 'integer':
    case 'float':
      return 'numeric';
    case 'boolean':
      // PrimeReact always hides the matchMode selector when dataType is 'boolean'.
      return control && control.type !== 'checkbox' ? 'text' : 'boolean';
    case 'date':
    case 'time':
      return 'date';
    case 'dateTime':
      return 'numeric';
    default:
      return undefined;
  }
};
